const checkokIcon = `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
    <title>Outline_Icons</title>
    <desc>Created with Sketch.</desc>
    <g id="Settings-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="DB-Settings--PS--Collage-Edit" transform="translate(-1003.000000, -580.000000)" stroke="#29CF70">
            <g id="Group-10-Copy" transform="translate(309.000000, 399.000000)">
                <g id="Group-8" transform="translate(0.000000, 42.000000)">
                    <g id="Group-6" transform="translate(23.000000, 15.000000)">
                        <g transform="translate(457.000000, 121.000000)" id="check-circle-2">
                            <g transform="translate(215.000000, 4.000000)">
                                <g id="Outline_Icons_1_">
                                    <g id="Outline_Icons">
                                        <g id="Group">
                                            <polyline id="Path" points="14.1666667 7.08333333 7.91666667 12.9166667 5.83333333 10.8333333"></polyline>
                                            <circle id="Oval" cx="10" cy="10" r="9.58333333"></circle>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
    `;

export default checkokIcon;
